import { render, staticRenderFns } from "./EditSurcharge.vue?vue&type=template&id=0c714df5"
import script from "./EditSurcharge.vue?vue&type=script&lang=js"
export * from "./EditSurcharge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports